import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import {
	DatePicker,
	Table,
	Spin
} from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
import {
	changeRecruitmentStatistics,
	selectRecruitmentStatistics,
} from "../../actions/recruitment-actions";

const webConfig = require ('../../config.json');
class RecruitmentStatistics extends ReduxComponent {

	initReload = true;
	deleteRowSelection = true;
	moduleName = "recruitment";
	childModuleName = "recruitmentStatistics";

	state = {
		currentModalStatus: false,
		currentIndex: false,
		currentData: {},
	}

	actions = {
		changeAction: this.props.changeRecruitmentStatistics,
		selectAction: this.props.selectRecruitmentStatistics,
	}

	//setDateFilter = (moment, date) => this.actions.changeAction({date: date}, "reload")
	setDateFilter = (moment, date) => this.actions.changeAction({keyword: date}, "reload")

	column = [{
			title: '日期',
			dataIndex: 'create_date',
			key: 'create_date',
			className: 'table-global-head-short'
		},{
			title: '简历数',
			dataIndex: 'statistics_count',
			key: 'statistics_count',
			className: 'table-global-head-short'
		}, {
			title: '面试数',
			dataIndex: 'interview_count',
			key: 'interview_count',
			className: 'table-global-head-short'
		}, {
			title: '录用审批数',
			dataIndex: 'recruitment_approval_count',
			key: 'recruitment_approval_count',
			className: 'table-global-head'
		}, {
			title: '录用人数',
			dataIndex: 'recruitment_count',
			key: 'recruitment_count',
			className: 'table-global-head'
		}, {
			title: '到岗人数',
			dataIndex: 'tothepost_count',
			key: 'tothepost_count',
			className: 'table-global-head'
		}
	];

	publicTableView = () => {
		switch (this.props[this.moduleName][this.childModuleName].dataStatus) {
			case "reload":
			case "loaded":
				return (
					<Table columns={this.column}
					dataSource={this.props[this.moduleName][this.childModuleName].data.Data}
					rowKey={record => record.create_date}
					scroll={{x: 800}}
					rowSelection={this.rowSelection}
					pagination={{
						total: this.props[this.moduleName][this.childModuleName].data.Total,
						pageSize: this.props[this.moduleName][this.childModuleName].data.PageSize,
						current: this.props[this.moduleName][this.childModuleName].filters.page}}
					onChange={this.setPageFilter} />)
			case "error":
				return (
					<div style={{textAlign:'center', margin: '100px 0px'}}>
						{webConfig.httpFetchErrorInformation}
					</div>);
			case "loading":
			case "unload":
				return (
					<div style={{textAlign:'center', margin: '100px 0px'}}>
						<Spin size="large" />
					</div>);
			default :
				return null;
		}
	}

	render() {
		return (
			<div className="app-module-item">
				<div style={{marginBottom: "20px"}}>
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<span style={{marginRight:"5px"}}>日期 : </span>
						<DatePicker onChange={this.setDateFilter}
							value={this.props[this.moduleName][this.childModuleName].filters.keyword ?
								moment(this.props[this.moduleName][this.childModuleName].filters.keyword, "YYYY-MM-DD") : null} />
					</div>
					<div style={{clear: "both"}}></div>
				</div>
				<div>{this.publicTableView()}</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		recruitment: state.recruitment
	}
}

const mapDispatchToProps = {
	changeRecruitmentStatistics,
	selectRecruitmentStatistics,
}


export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(RecruitmentStatistics));







// WEBPACK FOOTER //
// ./src/routes/Recruitment/RecruitmentStatistics.js